export const create = "report:create";
export const edit = "report:edit";
export const deletePermission = "report:delete";
